import { useTranslation } from "react-i18next";
import TableHeaderSortingButton from "../../../../../../../shared/components/button/TableHeaderSortingButton";
import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";
import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import UpdateClientProductDialog from "./UpdateClientProductDialog";

const ClientProductsTable = ({ data, onProductEdition, onProductDeletion }) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "category",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.products.table.category")}
          />
        );
      },
      cell: ({ row }) => row.original.category.name,
    },
    {
      accessorKey: "code",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.products.table.code")}
          />
        );
      },
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.products.table.name")}
          />
        );
      },
    },
    {
      accessorKey: "description",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.products.table.description")}
          />
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <UpdateClientProductDialog
              product={data}
              onSubmitHandler={(formValues) =>
                onProductEdition(data.id, formValues)
              }
            />
            <TableDeleteButton
              onClickHandler={() => onProductDeletion(data.id)}
            />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default ClientProductsTable;
